import { render, staticRenderFns } from "./SuratPenunjangList.vue?vue&type=template&id=f2c4491c&scoped=true&"
import script from "./SuratPenunjangList.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangList.vue?vue&type=script&lang=js&"
import style0 from "./SuratPenunjangList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SuratPenunjangList.vue?vue&type=style&index=1&id=f2c4491c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c4491c",
  null
  
)

export default component.exports